// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"818":"auth","966":"dashboard"}[chunkId] || chunkId) + "." + {"269":"1c9c5b33","392":"1cfdefa2","659":"c3a56ae5","818":"a0b1d0dd","966":"ee45672b"}[chunkId] + ".css";
};